<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        block
        class="white--text"
        v-on="on"
      >
        Create Leave Type
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Leave Type"
      text="Create Leave Type"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="leaveType"
              v-validate="'required'"
              :error-messages="errors.collect('leaveType')"
              data-vv-name="leaveType"  
              data-vv-as="leave type"  
              :items="leaveTypes"
              label="Name"
              item-text="name"
              return-object
              outlined
            />
          </v-col>
        </v-row>

        <v-row
          v-if="leaveType"
          class="font-weight-black"
        >
          <v-col
            cols="3"
            class="py-0"
          >
            <span> Is Paid Leave? </span>
            <v-radio-group
              v-model="leaveType.is_paid_leave"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> Is Prorated? </span>
            <v-radio-group
              v-model="leaveType.is_prorated"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> Is Bi-Yearly? </span>
            <v-radio-group
              v-model="leaveType.is_bi_yearly"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> Is Carry Forwardable? </span>
            <v-radio-group
              v-model="leaveType.is_carry_forwardable"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row
          v-if="leaveType"
          class="font-weight-black"
        >
          <v-col
            cols="3"
            class="py-0"
          >
            <span> Auto Select End Date? </span>
            <v-radio-group
              v-model="leaveType.is_continuous"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> Includes Public Holiday? </span>
            <v-radio-group
              v-model="leaveType.includes_public_holiday"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            class="py-0"
            cols="3"
          >
            <span> Includes Rest Day? </span>
            <v-radio-group
              v-model="leaveType.includes_rest_day"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            class="py-0"
            cols="3"
          >
            <span> Includes Off Day? </span>
            <v-radio-group
              v-model="leaveType.includes_off_day"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row
          v-if="leaveType"
          class="font-weight-black"
        >
          <v-col
            cols="3"
            class="py-0"
          >
            <span> Requires document? </span>
            <v-radio-group
              v-model="leaveType.requires_document"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> To Notify HR? </span>
            <v-radio-group
              v-model="leaveType.notify_hr"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> Requires Confirmation? </span>
            <v-radio-group
              v-model="leaveType.requires_confirmation"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> Allow Only Backdated Appl.? </span>
            <v-radio-group
              v-model="only_allow_backdated_application"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row
          v-if="leaveType"
          class="font-weight-black"
        >
          <v-col
            cols="3"
            class="py-0"
          >
            <div>
              <span> Supersede Priority </span>
              <v-text-field
                v-model="supersede_priority"
                v-validate="'required'"
                :error-messages="errors.collect('supersede_priority')"     
                data-vv-name="supersede_priority"
                data-vv-as="supersede priority"
                type="number"
                :min="1"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </div>
          </v-col>
          
          <v-col
            cols="3"
            class="py-0"
          >
            <span> Can Apply On Behalf? </span>
            <v-radio-group
              v-model="leaveType.is_apply_on_behalf"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
          
          <v-col
            cols="3"
            class="py-0"
          >
            <span> Requires Reason? </span>
            <v-radio-group
              v-model="leaveType.requires_reason"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            v-if="leaveType.requires_reason"
            class="py-0"
            cols="3"
          >
            <span> Min. Days Reason Required? </span>
            <v-text-field
              v-model="leaveType.minimum_days_reason_required"
              suffix="Day(s)"
              type="number"
              :min="0"
              @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
            />
          </v-col>
          <v-col
            cols="3"
            class="py-0"
          >
            <span> Has expiry date? </span>
            <v-radio-group
              v-model="leaveType.has_expiry_date"
              row
              @change="setDefaultExpiryDate"
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
          <v-col
            v-show="leaveType.has_expiry_date"
            cols="3"
            class="py-0"
          >
            <span> Expiry Date </span>
            <v-menu
              v-model="expiryDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="expiryDateDisplay"
                  v-validate="leaveType.has_expiry_date ? 'required' : ''"
                  :error-messages="errors.collect('expiryDateDisplay')"
                  data-vv-name="expiryDateDisplay"  
                  data-vv-as="expiry date"
                  class="label-position"
                  readonly
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="leaveType.expiry_date"
                no-title
                scrollable
                @input="expiryDateMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="3"
            class="py-0"
          >
            <span> Is Optional Leave Entitlement? </span>
            <v-radio-group
              v-model="leaveType.is_optional_leave_entitlement"
              row
              @change="setDefaultValue"
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            v-if="!leaveType.is_optional_leave_entitlement"
            cols="3"
            class="py-0"
          >
            <span> Is Lifetime? </span>
            <v-radio-group
              v-model="leaveType.is_lifetime"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            v-if="!leaveType.is_optional_leave_entitlement"
            cols="3"
            class="py-0"
          >
            <span> Requires Marital Status? </span>
            <v-radio-group
              v-model="leaveType.requires_marital_status"
              row
              :disabled="leaveType.non_editable_marital_status"
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
          
          <v-col
            v-if="leaveType.requires_marital_status && ![5].includes(leaveType.id)"
            class="py-0"
            cols="3"
          >
            <span>Marital Status</span>
            <v-autocomplete
              v-model="leaveType.marital_status_lookup_uid"
              v-validate="[5].includes(leaveType.id) ? '': leaveType.requires_marital_status ? 'required' : ''"
              :error-messages="errors.collect('marital_status_lookup_uid')"
              :items="marital_status"
              :disabled="leaveType.non_editable_marital_status_lookup"
              data-vv-name="marital_status_lookup_uid"     
              data-vv-as="marital status"            
              item-text="value"
              item-value="lookup_uid"
            />
          </v-col>

          <v-col
            v-if="(leaveType.marital_status_lookup_uid && checkMaritalStatus(leaveType.marital_status_lookup_uid, 'Married'))||[5].includes(leaveType.id)"
            class="py-0"
            cols="3"
          >
            <div>
              <span>Gender</span>
              <v-autocomplete
                v-model="leaveType.gender_lookup_uid"
                v-validate="leaveType.marital_status_lookup_uid && checkMaritalStatus(leaveType.marital_status_lookup_uid, 'Married') ? 'required' : ''"
                :error-messages="errors.collect('gender')"
                :items="gender"
                :disabled="leaveType.non_editable_gender_lookup"
                data-vv-name="gender"     
                data-vv-as="gender"            
                item-text="value"
                item-value="lookup_uid"
              />
            </div>
          </v-col>

          <v-col
            v-if="(leaveType.marital_status_lookup_uid && checkMaritalStatus(leaveType.marital_status_lookup_uid, 'Married'))||[5].includes(leaveType.id)"
            cols="3"
            class="py-0"
          >
            <div>
              <span> No. Of Children Eligible </span>
              <v-text-field
                v-model="leaveType.number_of_children_eligible"
                v-validate="'required'"
                :error-messages="errors.collect('number_of_children_eligible')"     
                data-vv-name="number_of_children_eligible"
                data-vv-as="number of children eligible"
                type="number"
                :min="0"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </div>
          </v-col>
        </v-row>
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"   
            class="white--text px-10"       
            @click="submitForm"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      combinedLeaveTypes: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,        
        progressing: false,
        expiryDateMenu: false,
        leaveTypes: [
          {
            id: 1,
            name: 'ANNUAL LEAVE',
            is_continuous: 0,
            is_paid_leave: 1,
            requires_document: 0,
            notify_hr: 0,
            requires_reason: 1,
            minimum_days_reason_required: 7,
            requires_confirmation: 1,
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 1,
            is_bi_yearly: 0,
            is_carry_forwardable: 1,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,   
            includes_public_holiday: 0,
            includes_rest_day: 0,
            includes_off_day: 0,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 2,
            name: 'SICK LEAVE',
            is_continuous: 0,
            is_paid_leave: 1,
            requires_document: 1,
            notify_hr: 1,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_confirmation: 0, 
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            includes_public_holiday: 0,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 3, 
            name: 'UNPAID LEAVE',
            requires_confirmation: 0, 
            is_paid_leave: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0, 
            requires_document: 0,
            notify_hr: 0,
            requires_reason: 1,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null, 
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,
            includes_public_holiday: 0,
            includes_rest_day: 0,
            includes_off_day: 0,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 4,
            name: 'PATERNITY LEAVE', 
            is_continuous: 1,
            is_paid_leave: 1,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_confirmation: 1, 
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 1,
            marital_status_lookup_uid: '1c661e3d-dbe1-11e7-ba92-509a4c2dfbad', 
            gender_lookup_uid: '1c661585-dbe1-11e7-ba92-509a4c2dfbad',
            number_of_children_eligible: 5,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: true,
            non_editable_gender_lookup: true,
            non_editable_marital_status: true,
          },
          {
            id: 5,
            name: 'MATERNITY LEAVE',
            is_continuous: 1,
            is_paid_leave: 1,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_confirmation: 0, 
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 1,
            marital_status_lookup_uid: null, 
            gender_lookup_uid: '1c66161e-dbe1-11e7-ba92-509a4c2dfbad',
            number_of_children_eligible: 5,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: true,
            non_editable_gender_lookup: true,
            non_editable_marital_status: true,
          },
          {
            id: 6,
            name: 'COMPASSIONATE LEAVE',
            requires_confirmation: 1, 
            is_paid_leave: 1,
            is_prorated: 0, 
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 1,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 7,
            name: 'MARRIAGE LEAVE',
            requires_confirmation: 1, 
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 1,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 1,
            marital_status_lookup_uid: '1c661dae-dbe1-11e7-ba92-509a4c2dfbad',
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: true,
            non_editable_gender_lookup: false,
            non_editable_marital_status: true,
          },
          {
            id: 8,
            name: 'EXAMINATION LEAVE',
            requires_confirmation: 1, 
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 9,
            name: 'NATURAL DISASTER LEAVE', 
            requires_confirmation: 1,
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 10,
            name: 'COVID - PAID TIME OFF',
            requires_confirmation: 0,
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,  
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 11,
            name: 'HOSPITALIZATION LEAVE',
            requires_confirmation: 0,
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 1,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,      
            includes_public_holiday: 0,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 12,
            name: 'PROLONG MEDICAL LEAVE',
            requires_confirmation: 1,
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 1,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 1,
            includes_public_holiday: 0,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 1,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 13,
            name: 'COVID - SWAB TESTING',
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,
            requires_confirmation: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 14,
            name: 'SUSPENSION LEAVE',
            is_paid_leave: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 1,
            requires_confirmation: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 1,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 15,
            name: 'UNPAID LEAVE > 14 DAYS',
            is_paid_leave: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 0,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 0,
            requires_confirmation: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 16,
            name: 'COMPANY QUARANTINE ORDER',
            is_paid_leave: 1,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            is_lifetime: 0,
            is_continuous: 0,
            requires_document: 1,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            is_optional_leave_entitlement: 1,
            requires_confirmation: 0,
            includes_public_holiday: 1,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 17,
            name: 'UNPAID SICK LEAVE',
            is_continuous: 0,
            is_paid_leave: 0,
            requires_document: 1,
            notify_hr: 1,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_confirmation: 0, 
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,
            includes_public_holiday: 0,
            includes_rest_day: 1,
            includes_off_day: 1,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 18,
            name: 'REPLACEMENT LEAVE',
            is_continuous: 0,
            is_paid_leave: 1,
            requires_document: 0,
            notify_hr: 0,
            requires_reason: 1,
            minimum_days_reason_required: 7,
            requires_confirmation: 0,
            is_optional_leave_entitlement: 1,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,   
            includes_public_holiday: 0,
            includes_rest_day: 0,
            includes_off_day: 0,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 19,
            name: 'BIRTHDAY LEAVE',
            is_continuous: 0,
            is_paid_leave: 1,
            requires_document: 0,
            notify_hr: 0,
            requires_reason: 0,
            minimum_days_reason_required: 0,
            requires_confirmation: 1,
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,   
            includes_public_holiday: 0,
            includes_rest_day: 0,
            includes_off_day: 0,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 20,
            name: 'TRAINING',
            is_continuous: 0,
            is_paid_leave: 1,
            requires_document: 0,
            notify_hr: 0,
            requires_reason: 1,
            minimum_days_reason_required: 0,
            requires_confirmation: 1,
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,   
            includes_public_holiday: 0,
            includes_rest_day: 0,
            includes_off_day: 0,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
          {
            id: 21,
            name: 'BUSINESS TRIP',
            is_continuous: 0,
            is_paid_leave: 1,
            requires_document: 0,
            notify_hr: 0,
            requires_reason: 1,
            minimum_days_reason_required: 0,
            requires_confirmation: 1,
            is_optional_leave_entitlement: 0,
            is_lifetime: 0,
            is_prorated: 0,
            is_bi_yearly: 0,
            is_carry_forwardable: 0,
            requires_marital_status: 0,
            marital_status_lookup_uid: null,
            gender_lookup_uid: null,
            number_of_children_eligible: 0,   
            includes_public_holiday: 0,
            includes_rest_day: 0,
            includes_off_day: 0,
            is_apply_on_behalf: 0,
            has_expiry_date: 0,
            expiry_date: null,
            non_editable_marital_status_lookup: false,
            non_editable_gender_lookup: false,
            non_editable_marital_status: false,
          },
        ],
        leaveType: null,
        only_allow_backdated_application: 0,
        supersede_priority: 0,
      }
    },
    computed: {
      ...mapState('lookup', ['title', 'gender', 'ethnicity', 'religion', 'marital_status', 'place_of_birth']),
      
      expiryDateDisplay () {
        return this.leaveType.expiry_date ? this.$moment(this.leaveType.expiry_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : null
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return 

        let largestSupersedePriorityValue = 0
        this.combinedLeaveTypes.forEach((combinedLeaveType, index) => {
          if (largestSupersedePriorityValue < combinedLeaveType.supersede_priority) { largestSupersedePriorityValue = combinedLeaveType.supersede_priority }
        })
        this.supersede_priority = largestSupersedePriorityValue

        let existingLeaveTypeIds = _.map(this.combinedLeaveTypes, 'id')

        this.leaveTypes = this.leaveTypes.filter(leaveType => {
          return !existingLeaveTypeIds.includes(leaveType.id)
        })
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.hrisLeaveTypes().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created')              
                  this.$snack({ message: 'Added new leave type' })
                  this.dialog = false                 
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
                this.$resetData()
              })
          })
      }, 
      setDefaultValue () {
        this.leaveType.requires_confirmation = 1
        if (this.leaveType.is_optional_leave_entitlement) {
          this.leaveType.is_lifetime = 0
          this.leaveType.requires_marital_status = 0
        } else {
          this.leaveType.is_lifetime = 0
          this.leaveType.requires_marital_status = 0
        }
      },

      prepareFormData () {
        if (this.leaveType.is_lifetime === 1) {
          this.leaveType.is_prorated = 0
          this.leaveType.is_bi_yearly = 0
          this.leaveType.is_carry_forwardable = 0
        }
        return {
          id: this.leaveType.id,
          name: this.leaveType.name,
          is_continuous: this.leaveType.is_continuous,
          is_paid_leave: this.leaveType.is_paid_leave,
          requires_document: this.leaveType.requires_document,
          notify_hr: this.leaveType.notify_hr,
          requires_reason: this.leaveType.requires_reason,
          minimum_days_reason_required: this.leaveType.requires_reason ? this.leaveType.minimum_days_reason_required : 0,
          requires_confirmation: this.leaveType.requires_confirmation,
          is_optional_leave_entitlement: this.leaveType.is_optional_leave_entitlement,
          is_lifetime: this.leaveType.is_lifetime,
          is_prorated: this.leaveType.is_prorated,
          is_bi_yearly: this.leaveType.is_bi_yearly,
          is_carry_forwardable: this.leaveType.is_carry_forwardable,
          requires_marital_status: this.leaveType.requires_marital_status,
          marital_status_lookup_uid: this.returnMaritalStatusLookupUid(),
          gender_lookup_uid: this.returnGenderLookupUid(),
          number_of_children_eligible: this.returnNumberOfChildrenEligible(),
          includes_public_holiday: this.leaveType.includes_public_holiday,
          includes_rest_day: this.leaveType.includes_rest_day,
          includes_off_day: this.leaveType.includes_off_day,
          is_apply_on_behalf: this.leaveType.is_apply_on_behalf,
          supersede_priority: this.supersede_priority,
          only_allow_backdated_application: this.only_allow_backdated_application,
          expiry_date: this.leaveType.expiry_date,
        }
      },

      returnMaritalStatusLookupUid () {
        if (![5].includes(this.leaveType.id)) { // maternity
          if (this.leaveType.requires_marital_status) {
            return this.leaveType.marital_status_lookup_uid
          } else {
            return null
          } 
        } else {
          return null
        }
      },

      returnGenderLookupUid () {
        if (this.leaveType.marital_status_lookup_uid) {
          if ([5].includes(this.leaveType.id)) { // maternity
            return '1c66161e-dbe1-11e7-ba92-509a4c2dfbad' // female
          } else if (this.leaveType.marital_status_lookup_uid === '1c661dae-dbe1-11e7-ba92-509a4c2dfbad') { // single
            return null
          } else if (this.leaveType.marital_status_lookup_uid === '1c661e3d-dbe1-11e7-ba92-509a4c2dfbad') { // married
            return this.leaveType.gender_lookup_uid
          }
        } else {
          return null
        }
      },

      returnNumberOfChildrenEligible () {
        if (this.leaveType.marital_status_lookup_uid) { 
          if ([5].includes(this.leaveType.id)) {
            return this.leaveType.number_of_children_eligible
          } else if (this.leaveType.marital_status_lookup_uid === '1c661dae-dbe1-11e7-ba92-509a4c2dfbad') { // single
            return 0
          } else if (this.leaveType.marital_status_lookup_uid === '1c661e3d-dbe1-11e7-ba92-509a4c2dfbad') { // married
            return this.leaveType.number_of_children_eligible
          }
        } else {
          return 0
        }
      },

      checkMaritalStatus (uid, value) {
        let maritalStatusLookup = this.marital_status.filter(status => status.lookup_uid === uid)
        if (maritalStatusLookup && maritalStatusLookup.length > 0 && maritalStatusLookup[0].value === value) {
          return true
        }
        return false
      },

      setDefaultExpiryDate () {
        if (!this.leaveType.has_expiry_date) {
          this.leaveType.expiry_date = null
        }
      },
    },
  }
</script>
